import Vue from 'vue'
import Router from 'vue-router'
import vote from './views/Vote.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: vote
    },
    {
      path: '/poster',
      name: 'poster',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "poster" */ './views/Poster.vue')
    }
  ]
})
